// The queries over the host (decision 064): the shell's local state, asked
// again every five seconds while the window is visible and when it regains
// focus, so nothing on this PC is ever a Refresh button away.

import { queryOptions } from "@tanstack/react-query";

import type { Host } from "./host";

/** How often the local state is asked for while the window is visible. */
export const LOCAL_REFRESH_MS = 5_000;

export const hostQueries = {
  info: (host: Host) =>
    queryOptions({
      queryKey: ["host", "info"],
      queryFn: () => host.appInfo(),
      refetchInterval: LOCAL_REFRESH_MS,
      staleTime: 1_000,
    }),
  status: (host: Host) =>
    queryOptions({
      queryKey: ["host", "status"],
      queryFn: () => host.status(),
      refetchInterval: LOCAL_REFRESH_MS,
      staleTime: 1_000,
    }),
  outbox: (host: Host) =>
    queryOptions({
      queryKey: ["host", "outbox"],
      queryFn: () => host.outbox(),
      refetchInterval: LOCAL_REFRESH_MS,
      staleTime: 1_000,
    }),
};
